import { render, staticRenderFns } from "./ExamList.vue?vue&type=template&id=27443fb0"
import script from "../../controllers/exam/exam-list.js?vue&type=script&lang=js&external"
export * from "../../controllers/exam/exam-list.js?vue&type=script&lang=js&external"
import style0 from "./ExamList.vue?vue&type=style&index=0&id=27443fb0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports